import { Fragment } from 'react'

import clsx from 'clsx'

import { useNavigate } from '@tribeplatform/react-components/Link'
import { Card } from '@tribeplatform/react-ui-kit/Card'

import type { StaticField } from '../../Views/types'
import { groupFieldsByStretchY } from '../../Views/utils'
import type { QuickLinksSource } from '../types'
import { Field } from './Field'

interface Props {
  source: QuickLinksSource
  fields: StaticField[]
  activeFieldId: string
  width?: number
  className?: string
  preview: boolean
}
export const QuickLinksGalleryItem = ({
  source,
  fields,
  activeFieldId,
  width,
  className,
  preview,
}: Props) => {
  const navigate = useNavigate()

  const bannerIsMiddle =
    fields.findIndex(
      field =>
        field.id === 'quickLinkGalleryBanner' &&
        field.settings?.bannerStyle === 'banner',
    ) > 0
  const bannerIsLast =
    fields.findIndex(
      field =>
        field.id === 'quickLinkGalleryBanner' &&
        field.settings?.bannerStyle === 'banner',
    ) ===
    fields.length - 1

  return (
    <Card
      onClick={() => navigate(source.linkUrl)}
      className={clsx(
        'cursor-pointer hover:shadow-lg transition-all ease-in-out duration-200',
        'overflow-hidden justify-start stretch',
        className,
      )}
      {...(width
        ? { style: { maxWidth: `${width}px`, minWidth: `${width}px` } }
        : {})}
    >
      {bannerIsMiddle && (
        <Card.Content
          className={clsx(
            !bannerIsLast && 'flex-grow-0',
            'flex flex-col gap-4',
          )}
        >
          {groupFieldsByStretchY(
            fields
              .filter((_, index) => {
                const bannerIndex = fields.findIndex(
                  field =>
                    field.id === 'quickLinkGalleryBanner' &&
                    field.settings?.bannerStyle === 'banner',
                )
                return bannerIndex === -1 || index < bannerIndex
              })
              .filter(field => !field.settings?.snapBottom),
          ).map(group => (
            <div
              key={group[0].id}
              className={clsx(
                group[0].settings?.stretchY ? 'flex-1' : 'grow-0 shrink-0',
              )}
            >
              <div className="flex flex-wrap items-center gap-4">
                {group.map(field => (
                  <Field
                    key={field.id}
                    field={field}
                    source={source}
                    activeFieldId={activeFieldId}
                    viewStyle="gallery"
                    preview={preview}
                  />
                ))}
              </div>
            </div>
          ))}
        </Card.Content>
      )}
      {fields.map(field => (
        <Fragment key={field.id}>
          {field.id === 'quickLinkGalleryBanner' &&
            field.settings?.bannerStyle === 'banner' && (
              <Card.Media>
                <Field
                  key={field.id}
                  field={field}
                  source={source}
                  activeFieldId={activeFieldId}
                  viewStyle="gallery"
                  preview={preview}
                />
              </Card.Media>
            )}
        </Fragment>
      ))}
      {!bannerIsLast && (
        <Card.Content className="flex flex-col gap-4">
          {groupFieldsByStretchY(
            fields
              .filter((_, index) => {
                const bannerIndex = fields.findIndex(
                  field =>
                    field.id === 'quickLinkGalleryBanner' &&
                    field.settings?.bannerStyle === 'banner',
                )
                return index > bannerIndex
              })
              .filter(field => !field.settings?.snapBottom),
          ).map(group => (
            <div
              key={group[0].id}
              className={clsx(
                group[0].settings?.stretchY ? 'flex-1' : 'grow-0 shrink-0',
              )}
            >
              <div className="flex flex-wrap items-center gap-4">
                {group.map(field => (
                  <Field
                    key={field.id}
                    field={field}
                    source={source}
                    activeFieldId={activeFieldId}
                    viewStyle="gallery"
                    preview={preview}
                  />
                ))}
              </div>
            </div>
          ))}
        </Card.Content>
      )}
      {fields.map(field => (
        <Fragment key={field.id}>
          {field.settings?.snapBottom && (
            <Card.Footer>
              <Field
                key={field.id}
                field={field}
                source={source}
                activeFieldId={activeFieldId}
                viewStyle="gallery"
                preview={preview}
              />
            </Card.Footer>
          )}
        </Fragment>
      ))}
    </Card>
  )
}
